(ns app.front.view.admin.commands.business-delete
  (:require [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::state
  :-> ::state)

(rf/reg-event-db ::set-entity-id
  (rf/path [::state])
  (fn [state [_ entity-id]]
    (-> state
        (assoc :entity-id entity-id)
        (dissoc :preview :deleted?))))

(rf/reg-event-fx ::preview
  (fn [_ [_ entity-id]]
    {:comm/command {:command    :admin/get-business-for-deletion
                    :method     :get
                    :data       (util/mmap entity-id)
                    :on-success [::preview-success]}}))

(rf/reg-event-db ::preview-success
  (rf/path [::state])
  (fn [state [_ _status preview]]
    (-> state
        (assoc :preview preview)
        (dissoc :deleted?))))

(rf/reg-event-fx ::delete
  (fn [_ [_ entity-id]]
    {:comm/command {:command    :admin/delete-business
                    :data       (util/mmap entity-id)
                    :on-success [::delete-success]}}))

(rf/reg-event-fx ::delete-success
  (fn [{:keys [db]} [_ status response]]
    {:db (-> db
             (assoc-in [::state :deleted?] true)
             (update ::state dissoc :preview))
     :fx [[:dispatch [::entities/apply-changes status response]]]}))

(def blocker-labels
  {:business-delete.blocker/workspaces               "Used as a party in workspaces"
   :business-delete.blocker/licences                 "Linked licences"
   :business-delete.blocker/contractor-registrations "Linked contractor registrations"
   :business-delete.blocker/escrow-accounts          "Owned escrow accounts"
   :business-delete.blocker/bonds                    "Owned bonds"
   :business-delete.blocker/properties               "Associated properties"
   :business-delete.blocker/members                  "Business members"
   :business-delete.blocker/tasks                    "Active or historical tasks"
   :business-delete.blocker/child-records            "Business-owned records"
   :business-delete.blocker/external-authorizations  "Permissions to external records"
   :business-delete.blocker/shared-domain-group      "Another business uses the same domain group"})

(defn- deletion-blockers-view [blockers]
  [:div.mt-6
   [:h4 "Deletion blocked"]
   [:p.mb-4 "Remove the following links before deleting this business:"]
   [:ul.list-disc.ml-6
    (futil/for-frag [{:keys [reason entity-ids]} blockers]
      [:li.mb-2
       [:span.font-bold (get blocker-labels reason (name reason))]
       (str " (" (count entity-ids) ")")
       [:div.text-sm (str "Related Entity IDs: " (str/join ", " entity-ids))]])]])

(defn- business-preview [{:keys [business deletion-blockers delete-entity-count]}]
  (let [{:business/keys [name unique-id]
         entity-id      :db/id}          business]
    [:section.mt-6
     [:h3 name]
     [:dl.mt-4
      [:dt.font-bold "Entity ID"]
      [:dd entity-id]
      [:dt.font-bold.mt-2 "Business unique ID"]
      [:dd unique-id]
      [:dt.font-bold.mt-2 "Entities in the internal deletion closure"]
      [:dd delete-entity-count]]
     (if (seq deletion-blockers)
       [deletion-blockers-view deletion-blockers]
       [ui/modal-confirmation-button
        {:id                  "business-delete"
         :tr                  (<sub [:tr])
         :dangerous?          true
         :trigger-button-text "Delete business"
         :trigger-button-opts {:kind       :danger
                               :class-name "mt-6"}
         :on-yes-click        #(>evt [::delete entity-id])}
        [:p.bold (str "Delete " name " and its " delete-entity-count " internal entities?")]
        [:p "This operation is effectively irreversible."]])]))

(defn- tool []
  (let [{:keys [entity-id preview deleted?]} (<sub [::state])]
    [:section
     [:p "Delete a business that was created in error. The business can only be deleted when it has no external "
      "relationships. Its domain group, child groups, grants, internal authorizations, and localized names are deleted "
      "with it."]
     [:form.flex.items-end.mt-6
      {:on-submit (fn [event]
                    (.preventDefault event)
                    (>evt [::preview entity-id]))}
      [ui/number-input {:id         "delete-business-entity-id"
                        :label-text "Entity ID of the business to delete"
                        :value      entity-id
                        :required   true
                        :on-change  #(rf/dispatch-sync [::set-entity-id (parse-long (futil/tval %))])}]
      [:div.ml-2
       [cc/button {:type     :submit
                   :disabled (not (integer? entity-id))}
        "Find business"]]]
     (when preview
       [business-preview preview])
     (when deleted?
       [:h4.mt-6 (str "Business " entity-id " deleted.")])]))

(defn view [match]
  [acommon/admin-page
   (util/mmap {:title "Delete unused business"} match)
   [tool]])

(def route
  {:name :view/admin.commands.business-delete
   :view view})
